import Vue from 'vue';
export default Vue.extend({
    name: 'selectCustom',
    data: function () {
        return {
            isAddCostType: true,
            otherTypeForm: {
                otherType: '',
            },
            otherTypeRules: {
                otherType: [
                    { required: true, message: '请输入费用类型', trigger: 'blur' },
                    { max: 5, message: '最多输入5个字', trigger: 'blur' },
                    { required: true, validator: this.isReapeat, trigger: 'blur' },
                ],
            },
        };
    },
    props: {
        options: {
            type: Array,
            default: function () {
                return [{}];
            },
        },
        detailForm: {
            type: Object,
            required: true,
        },
        currentKeys: {
            type: Object,
            required: true,
        },
        callback: {
            type: Function,
            default: function () {
                return null;
            },
        },
        disabled: {
            type: Boolean,
            default: function () {
                return false;
            },
        },
    },
    computed: {
        optionsModel: function () {
            return Object.assign([], this.options);
        },
        cKeys: function () {
            var keys = this.currentKeys;
            if (typeof keys === 'object' && keys !== null) {
                var type = keys.type, typeText = keys.typeText, val = keys.val;
                type === undefined && (keys.type = 'cTypes');
                typeText === undefined && (keys.typeText = 'cTypeText');
                val === undefined && (keys.val = 'OTHER');
                return keys;
            }
            return {
                type: 'cTypes',
                typeText: 'cTypeText',
                val: 'OTHER',
            };
        },
    },
    methods: {
        isReapeat: function (rule, value, callback) {
            var reg = /(^\s*)|(\s*$)/g;
            var val = value.replace(reg, '');
            var isHasOtherType = false;
            this.optionsModel.forEach(function (option) {
                if (option.val === val) {
                    isHasOtherType = true;
                }
            });
            if (isHasOtherType) {
                return callback(new Error('该项已存在'));
            }
            callback();
        },
        formatterVal: function (val) {
            if (val.match(/_CUSTOM_&&/)) {
                var keys = this.cKeys;
                this.optionsModel.forEach(function (option) {
                    if (option.val === 'OTHER') {
                        option.val = "_CUSTOM_&&" + option.label;
                    }
                    if (option.val === val) {
                        option.val = 'OTHER';
                    }
                });
                this.detailForm[keys.type] = 'OTHER';
                this.detailForm[keys.typeText] = val.split('_CUSTOM_&&')[1];
            }
            this.callback && this.callback(val);
        },
        saveOther: function () {
            var _this = this;
            this.$refs['otherTypeForm'].validate(function (valid) {
                if (!valid)
                    return;
                var otherType = _this.otherTypeForm.otherType;
                var isHasOtherType = false;
                var reg = /(^\s*)|(\s*$)/g;
                otherType = otherType.replace(reg, '');
                _this.optionsModel.push({
                    val: "_CUSTOM_&&" + otherType,
                    label: otherType,
                });
                _this.initOther();
            });
        },
        cancle: function () {
            this.initOther();
        },
        toggle: function (flag) {
            if (!flag)
                return;
            this.initOther();
        },
        initOther: function () {
            ;
            (this.isAddCostType = true), (this.otherTypeForm.otherType = '');
        },
    },
});
